import React from "react";
import document from "./documents/document.txt";

class Help extends React.Component {

    render() {
        return (
            <div className="HelpDiv">
                <a className="HelpText" href={document} download="Документація.txt">
                    Потрібна допомога? Завантаж документ за цим посиланням!
                </a>
            </div>
        )
    }
}

export default Help